import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';

import { getQuote, getPaymentOptions, getIsCashSelected } from '../selectors';

/**
 * @param {Object} state
 * @returns {Object}
 */
const getVehicle = state => {
    const { vehicle } = getQuote(state);

    return isPlainObject(vehicle) ? vehicle : {};
};

/**
 * @param {Object} state
 * @returns {Number}
 */
const getVehicleId = state => {
    const { id } = getVehicle(state);

    return id;
};

/**
 * @param {Object} state
 * @returns {Boolean}
 */
const getIsCatalog = state => {
    const { condition, stockNumber } = getVehicle(state);

    return condition === 'new' && isEmpty(stockNumber);
};

/**
 * @param {Object} state
 * @returns {Boolean}
 */
const getIsDemo = state => {
    const { condition, isDemo } = getVehicle(state);

    return isDemo === true || condition === 'demonstrator';
};

/**
 * @param {Object} state
 * @returns {Boolean}
 */
const getIsUsed = state => {
    const { condition } = getVehicle(state);

    return condition === 'used';
};

/**
 * @param {Object} state
 * @returns {Object}
 */
const getNewIncentive = state => {
    const { newIncentiveDisclaimer, newIncentiveIsMoreFavorable } = getQuote(state);

    return {
        disclaimer: newIncentiveDisclaimer,
        isMoreFavorable: newIncentiveIsMoreFavorable
    };
};

/**
 * @param {Object} state
 * @returns {Object}
 */
const getPaymentDetails = state => {
    const isCashSelected = getIsCashSelected(state);
    const { cashPurchase, finance } = getQuote(state);
    const {
        cashDown,
        kmPerYearPlan,
        paymentFrequency,
        purchaseMethod,
        tradeIn
    } = getPaymentOptions(state);

    let exclusionsDisclaimer;
    let incentives;
    let inclusionsDisclaimer;
    let rebate;
    let sellingPrice;
    let term = {};

    if (isCashSelected && isPlainObject(cashPurchase)) {
        let retailDetails;

        ({ incentives, retailDetails, sellingPrice } = cashPurchase);

        if (isPlainObject(retailDetails)) {
            ({ exclusionsDisclaimer, inclusionsDisclaimer } = retailDetails);
        }
    } else if (isPlainObject(finance)) {
        ({
            exclusionsDisclaimer,
            incentives,
            inclusionsDisclaimer,
            term
        } = finance);
    }

    if (isPlainObject(incentives)) {
        ({ total: rebate } = incentives);
    }

    return {
        cashDown,
        exclusionsDisclaimer,
        inclusionsDisclaimer,
        kmPerYearPlan,
        paymentFrequency,
        purchaseMethod,
        rebate,
        sellingPrice,
        term,
        tradeIn
    };
};

export {
    getVehicle,
    getVehicleId,
    getIsCatalog,
    getIsDemo,
    getIsUsed,
    getNewIncentive,
    getPaymentDetails
};
